import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiClock } = FiIcons;

const TimeSlots = ({ selectedTime, onTimeSelect }) => {
  const slots = [
    '09:00 AM', '10:00 AM', '11:00 AM', 
    '12:00 PM', '01:00 PM', '02:00 PM', 
    '03:00 PM', '04:00 PM', '05:00 PM', 
    '06:00 PM', '07:00 PM', '08:00 PM'
  ];

  return (
    <div className="p-6 border-t border-gray-700/50">
      <div className="flex items-center space-x-2 mb-4">
        <SafeIcon icon={FiClock} className="text-blue-400" />
        <h3 className="text-sm font-semibold text-white uppercase tracking-wider">Available Time Slots</h3>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
        {slots.map((time) => (
          <button
            key={time}
            onClick={() => onTimeSelect(time)}
            className={`
              py-2 px-3 rounded-lg text-sm font-medium transition-all duration-300 border
              ${selectedTime === time 
                ? 'bg-blue-600 border-blue-500 text-white shadow-lg scale-105' 
                : 'bg-gray-800/50 border-gray-700 text-gray-400 hover:border-blue-500/50 hover:text-blue-300'}
            `}
          >
            {time}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TimeSlots;